export default class ActionDetailsResponse {
    constructor(supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: '<span></span>',
                verificationInstruction: '<span></span>',
            };
        });

        this.coinsToEarn = null;
        this.verificationCoinsToEarn = null;
        this.availabilityInStatistics = null;

        this.activeFrom = null;
        this.activeTo = null;
        this.verificationMaxDate = null;
        this.latitude = null;
        this.longitude = null;
        this.localizationTolerance = null;
        this.actionType = null;
        this.supportedLocales = supportedLocales;
        this.publishedToCompanies = [];
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.status = from.status;
            to.coinsToEarn = from.coinsToEarn;
            to.verificationCoinsToEarn = from.verificationCoinsToEarn;
            to.availabilityInStatistics = from.availabilityInStatistics;

            to.activeFrom = new Date(from.activeFrom);
            to.activeTo = new Date(from.activeTo);
            to.verificationMaxDate = new Date(from.verificationMaxDate);
            to.longitude = from.longitude;
            to.latitude = from.latitude;
            to.localizationTolerance = from.localizationTolerance;
            to.actionType = from.actionType;
            to.icon = from.icon;
            to.photo = from.photo;
            to.publishedToCompanies = from.publishedToCompanies || [];

            to.supportedLocales.forEach((element) => {
                to.translations[element] = {
                    title: from.translations[element]?.title,
                    description: from.translations[element]?.description,
                    verificationInstruction: from.translations[element]?.verificationInstruction,
                };
            });
        } else {
            to = new ActionDetailsResponse();
        }
    }

    static copy(to, from) {
        ActionDetailsResponse.assign(from, to);
        return to;
    }
}
